import { CarIcon, CheckIcon, ScaleIcon, ShieldCheckIcon } from 'lucide-react';
import { step, type Step } from '@/flows/marketplace/state/step.js';

/**
 * Total, so adding a `Step` is a compile error rather than a silent default.
 *
 * Everything after `tiers` is step 3; adding another plan returns to step 2.
 */
const STEP_TO_INDEX: Record<Step, number> = {
  entry: 1,
  tiers: 2,
  payment: 3,
  'add-another': 3,
  'customer-info': 3,
};

const STEPS = [
  { label: 'Tell us about your vehicle', icon: CarIcon },
  { label: 'Compare your options', icon: ScaleIcon },
  { label: 'Choose your coverage', icon: ShieldCheckIcon },
];

export function ProgressBar() {
  const current = STEP_TO_INDEX[step.value];

  return (
    <ol className="sm-progress" aria-label={`Step ${current} of ${STEPS.length}`}>
      {STEPS.map(({ label, icon: Icon }, i) => {
        const index = i + 1;
        const state = index < current ? 'done' : index === current ? 'current' : undefined;
        return (
          <li
            key={label}
            className="sm-stack sm-progress-step"
            data-state={state}
            aria-current={index === current ? 'step' : undefined}
          >
            <span className="sm-center sm-progress-dot">
              {state === 'done' ? (
                <CheckIcon size={18} aria-hidden="true" />
              ) : (
                <Icon size={18} aria-hidden="true" />
              )}
            </span>
            <span className="sm-type-caption sm-progress-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
